module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/_iterators.js
 ** module id = 15
 ** module chunks = 0
 **/